import { render, staticRenderFns } from "./Completion.vue?vue&type=template&id=5d214e20&scoped=true&"
import script from "./Completion.vue?vue&type=script&lang=js&"
export * from "./Completion.vue?vue&type=script&lang=js&"
import style0 from "./Completion.vue?vue&type=style&index=0&id=5d214e20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d214e20",
  null
  
)

export default component.exports